import React, { Component } from "react";
// import {Link} from 'react-router-dom'
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBRow, MDBCol } from "mdbreact";

import content from "../Helpers/home-content-data";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol size="6" sm="4" key={key}>
          <MDBCard style={{ textAlign: "justify" }}>
            {/* <MDBCardImage>Hello</MDBCardImage> */}
            <div style={{ height: "220px", backgroundColor: "#fff" }}></div>
            <MDBCardBody>
              <h5>{item.caption}</h5>
              {/* <MDBCardText> */}
              {item.description}
              {/* </MDBCardText> */}
              {/* <div style={{align:"right"}}><h6 >More</h6></div> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow>{cards}</MDBRow>
      </div>
    );
  }
}

export default HomeCardDeck;
